<template>
  <fieldset class="grid grid-cols-1 md:grid-cols-2 gap-[2rem] gap-y-[1.563rem]">
    <slot />
  </fieldset>
</template>